(function() {
    'use strict';

    let EstinzioneCtrl = function(
        $uibModalInstance
    ) {

        this.prosegui = () => {
            $uibModalInstance.close();
        };

        this.chiudi = () => {
            $uibModalInstance.dismiss();
        };
    };

    EstinzioneCtrl.$inject = [
        '$uibModalInstance'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .controller('MitomEstinzioneController', EstinzioneCtrl);
})();